import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

const RouteFallback = () => <div className="route-fallback" aria-hidden />;

const Initial = lazy(() => import("./Pages/Initial/Initial"));
const About = lazy(() => import("./Pages/About/About.jsx"));
const Error404 = lazy(() => import("./Pages/Error404/Error404.jsx"));

const PlaceUP = lazy(() =>
  import("./Components/Pages/AboutPage/Projects/ProjectsPages/PlaceUP.jsx")
);
const BabaKing = lazy(() =>
  import("./Components/Pages/AboutPage/Projects/ProjectsPages/BabaKing.jsx")
);
const OduduwaCursos = lazy(() =>
  import(
    "./Components/Pages/AboutPage/Projects/ProjectsPages/OduduwaCursos.jsx"
  )
);
const Raira = lazy(() =>
  import("./Components/Pages/AboutPage/Projects/ProjectsPages/Raira.jsx")
);
const InstitutoKos = lazy(() =>
  import("./Components/Pages/AboutPage/Projects/ProjectsPages/InstitutuKos.jsx")
);
const InstitutoKosInstitucional = lazy(() =>
  import(
    "./Components/Pages/AboutPage/Projects/ProjectsPages/InstitutoKosInstitucional.jsx"
  )
);
const DoutorBomCusto = lazy(() =>
  import(
    "./Components/Pages/AboutPage/Projects/ProjectsPages/DoutorBomCusto.jsx"
  )
);
const Portfolio = lazy(() =>
  import("./Components/Pages/AboutPage/Projects/ProjectsPages/Portfolio.jsx")
);
const CirurgiaCenter = lazy(() =>
  import(
    "./Components/Pages/AboutPage/Projects/ProjectsPages/CirurgiaCenter.jsx"
  )
);
const Siok = lazy(() =>
  import("./Components/Pages/AboutPage/Projects/ProjectsPages/Siok.jsx")
);
const DrBrunoCorreia = lazy(() =>
  import(
    "./Components/Pages/AboutPage/Projects/ProjectsPages/DrBrunoCorreia.jsx"
  )
);
const Toka = lazy(() =>
  import("./Components/Pages/AboutPage/Projects/ProjectsPages/Toka.jsx")
);
const DrLuisBortolan = lazy(() =>
  import(
    "./Components/Pages/AboutPage/Projects/ProjectsPages/DrLuisBortolan.jsx"
  )
);
const DraLudmillaRangel = lazy(() =>
  import(
    "./Components/Pages/AboutPage/Projects/ProjectsPages/DraLudmillaRangel.jsx"
  )
);
const IdealLaser = lazy(() =>
  import("./Components/Pages/AboutPage/Projects/ProjectsPages/IdealLaser.jsx")
);
const Ora = lazy(() =>
  import("./Components/Pages/AboutPage/Projects/ProjectsPages/Ora.jsx")
);

export function Router() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="*" element={<Error404 />} />
        <Route path="/" element={<Initial />} />
        <Route path="/about" element={<About />} />
        <Route path="/sobre" element={<About />} />
        <Route path="/projetos/placeup" element={<PlaceUP />} />
        <Route path="/projetos/babaking" element={<BabaKing />} />
        <Route path="/projetos/oduduwacursos" element={<OduduwaCursos />} />
        <Route path="/projetos/raira" element={<Raira />} />
        <Route path="/projetos/institutokos" element={<InstitutoKos />} />
        <Route
          path="/projetos/institutokosinstitucional"
          element={<InstitutoKosInstitucional />}
        />
        <Route path="/projetos/doutorbomcusto" element={<DoutorBomCusto />} />
        <Route path="/projetos/portfolio" element={<Portfolio />} />
        <Route path="/projetos/cirurgiacenter" element={<CirurgiaCenter />} />
        <Route path="/projetos/siok" element={<Siok />} />
        <Route path="/projetos/drbrunocorreia" element={<DrBrunoCorreia />} />
        <Route path="/projetos/toka" element={<Toka />} />
        <Route
          path="/projetos/DrLuisBortolan"
          element={<DrLuisBortolan />}
        />{" "}
        <Route
          path="/projetos/DraLudmillaRangel"
          element={<DraLudmillaRangel />}
        />
        <Route path="/projetos/IdealLaser" element={<IdealLaser />} />
        <Route path="/projetos/Ora" element={<Ora />} />
      </Routes>
    </Suspense>
  );
}
